import Pusher from "pusher-js";

let pusherInstance: Pusher | null = null;
let pusherConfigKey: string | null = null;

export const getPusher = (appKey: string, wsHost: string): Pusher => {
  const host = wsHost.replace(/^https?:\/\//, "");
  const configKey = `${appKey}::${host}`;

  if (!pusherInstance || pusherConfigKey !== configKey) {
    pusherInstance?.disconnect();
    pusherInstance = new Pusher(appKey, {
      wsHost: host,
      wsPort: 443,
      wssPort: 443,
      forceTLS: true,
      disableStats: true,
      enabledTransports: ["ws", "wss"],
      cluster: "mt1"
    });
    pusherConfigKey = configKey;
  }

  return pusherInstance;
};
